const mediaItems = [
  {
    title: '独家揭秘：某顶流男星恋情时间线全整理',
    duration: '12:35',
    views: '38.2万',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20timeline%20visualization%20with%20warm%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20golden%20hour%20tones%2C%20clean%20composition%2C%20soft%20shadows%2C%20film%20grain%20texture%2C%20romantic%20vibe&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '深度复盘：某品牌代言人风波完整脉络',
    duration: '18:22',
    views: '25.7万',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20corporate%20boardroom%20with%20dramatic%20shadows%20and%20warm%20lighting%2C%20editorial%20photography%2C%20clean%20minimal%20composition%2C%20professional%20atmosphere%2C%20high%20contrast%2C%20soft%20texture&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '直播翻车现场实录：那些让人笑到打鸣的名场面',
    duration: '08:47',
    views: '42.1万',
    img: 'https://readdy.ai/api/search-image?query=A%20funny%20livestreaming%20studio%20scene%20with%20colorful%20props%20and%20warm%20lighting%2C%20playful%20atmosphere%2C%20editorial%20photography%2C%20clean%20composition%2C%20vibrant%20yet%20soft%20tones%2C%20entertaining%20vibe&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '吃瓜群像：最有料的投稿爆料大合集',
    duration: '15:10',
    views: '29.3万',
    img: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20newspaper%20clippings%20and%20magnifying%20glass%20on%20a%20wooden%20desk%2C%20investigative%20journalism%20style%2C%20warm%20vintage%20tones%2C%20editorial%20photography%2C%20clean%20composition%2C%20soft%20dramatic%20shadows&width=800&height=500&seq=media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
          <i className="ri-play-circle-line text-primary-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
          视频吃瓜
        </h2>
        <p className="text-sm text-foreground-500 mb-8">吃瓜怎能只看文字？51吃瓜网今日吃瓜视频版更精彩</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden group cursor-pointer hover:border-primary-200 transition-colors duration-200"
            >
              <div className="aspect-video w-full bg-background-100 relative overflow-hidden">
                <img
                  src={item.img}
                  alt={`视频吃瓜 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-200"></div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-[10px] font-mono rounded whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-90 group-hover:opacity-100 transition-opacity duration-200">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5 w-6 h-6 flex items-center justify-center"></i>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-bold text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">{item.title}</h3>
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                  {item.views} 次播放
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}